import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EmailStatusService {
  selectedDocCode = signal<string | null>(null);
  showEmailStatusModal = signal(false);

  onCloseModal() {
    this.showEmailStatusModal.set(false);
    this.selectedDocCode.set(null);
  }

  onOpenModal(docCode: string) {
    this.selectedDocCode.set(docCode);
    this.showEmailStatusModal.set(true);
  }
}
